import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage } from 'react-intl';
import type { Driver } from '../../../../types';
import { formatDriverNameForDisplay } from '../../utils';

interface ArchiveDriverDialogProps {
    driver: Driver | null;
    onConfirmArchiveDriver: () => void;
    onCancelArchiveDriver: () => void;
}

export const ArchiveDriverDialog = (props: ArchiveDriverDialogProps) => {
    const { driver, onConfirmArchiveDriver, onCancelArchiveDriver } = props;

    return (
        <ConfirmationDialog
            show={true}
            bsSize='sm'
            useOverflow={true}
            title={<FormattedMessage id='intl-msg:multiSelect.archive.title' />}
            content={
                <FormattedMessage
                    id='intl-msg:dialog.archiveDriver.content'
                    defaultMessage='Do you want to archive {driverName}?'
                    values={{ driverName: formatDriverNameForDisplay(driver) }}
                />
            }
            onClickConfirm={onConfirmArchiveDriver}
            onClickCancel={onCancelArchiveDriver}
            cancelButtonAutoTrackingKey='drivers.archive-driver.cancel'
            confirmButtonAutoTrackingKey='drivers.archive-driver.confirm'
            cancelButtonText={
                <div data-testid='cancelArchiveDriver'>
                    <FormattedMessage id='intl-msg:abort' />
                </div>
            }
            confirmButtonText={
                <div data-testid='confirmArchiveDriver'>
                    <FormattedMessage id='intl-msg:multiSelect.archive.title' />
                </div>
            }
        />
    );
};
